import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/main.css";
import store from "./store";
import router from "./router";
import DateFormatter from "@/utils/DateFormatter";
import VueApexCharts from "vue3-apexcharts";
import PrimeVue from 'primevue/config'
import 'primeicons/primeicons.css'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// import { quillEditor } from 'vue-quill'
// import 'quill/dist/quill.snow.css'

// Create the app instance first
const app = createApp(App);

// Register global formatter
app.config.globalProperties.$formatDate = DateFormatter.formatDate;

// Use plugins and mount
app.use(store).use(router).mount("#app");

// Register ApexCharts globally
app.use(VueApexCharts);

// Use PrimeVue
app.use(PrimeVue);

// Register QuillEditor globally
app.component('QuillEditor', QuillEditor);
